import merge from 'lodash/merge';
import { useMemo } from 'react';
// @mui
import { alpha, ThemeProvider, createTheme, useTheme } from '@mui/material/styles';
//
import { initialState, useSettingsContext } from './SettingsContext';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function ThemeColorPresets({ children }: Props) {
  const outerTheme = useTheme();

  const { presetsColor } = useSettingsContext();

  const themeColorPresets = presetsColor || initialState.presetsColor

  const themeOptions = useMemo(
    () => ({
      palette: {
        primary: themeColorPresets,
      },
      customShadows: {
        primary: `0 8px 16px 0 ${alpha(themeColorPresets.main, 0.24)}`,
      },
    }),
    [themeColorPresets]
  );

  const theme = createTheme(merge(outerTheme, themeOptions));

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
